var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9996 4H9.99985C6.70023 4 4 6.70023 4 9.99985V22.0001C4 25.2989 6.70023 28 9.99985 28H21.9996C25.2992 28 27.9994 25.2989 27.9994 22.0001V9.99985C27.9994 6.70023 25.2992 4 21.9996 4ZM25.9994 22.0001C25.9994 24.2051 24.2057 26 21.9996 26H9.99985C7.79461 26 6.00005 24.2051 6.00005 22.0001V9.99985C6.00005 7.79432 7.79461 6.00005 9.99985 6.00005H21.9996C24.2057 6.00005 25.9994 7.79432 25.9994 9.99985V22.0001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5005 10.9999C23.3289 10.9999 24.0004 10.3284 24.0004 9.49996C24.0004 8.67156 23.3289 8 22.5005 8C21.672 8 21.0005 8.67156 21.0005 9.49996C21.0005 10.3284 21.672 10.9999 22.5005 10.9999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9994 10C12.685 10 9.99951 12.6858 9.99951 15.9999C9.99951 19.3127 12.685 22.0003 15.9994 22.0003C19.3128 22.0003 21.9992 19.3127 21.9992 15.9999C21.9992 12.6858 19.3128 10 15.9994 10ZM15.9994 20.0002C13.7905 20.0002 11.9996 18.2093 11.9996 15.9999C11.9996 13.7904 13.7905 12 15.9994 12C18.2082 12 19.9992 13.7904 19.9992 15.9999C19.9992 18.2093 18.2082 20.0002 15.9994 20.0002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.88ef6a88bc41307ec2491e3b2ec7cc38.svg";
export { ForwardRef as ReactComponent };